import type { RouteLocationNormalizedLoaded } from 'vue-router'

function extractPathname(url: string): string {
  try {
    return new URL(url, 'http://localhost').pathname.replace(/\/$/, '')
  } catch {
    return url
  }
}

export function isActivePage(
  route: RouteLocationNormalizedLoaded,
  link: string | undefined,
) {
  if (!link) return false

  return extractPathname(route.fullPath) === extractPathname(link)
}
